import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {PaymentRoutingModule} from './payment-routing.module';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {HttpClientModule} from '@angular/common/http';
import {ChartModule} from 'angular-highcharts';
import { PaymentAddComponent } from './payment-add/payment-add.component';
import {PricingService} from './pricing.service';
import { PaymentDetailsComponent } from './payment-details/payment-details.component';
import {PaymentService} from './payment.service';
import { PaymentSuccessComponent } from './payment-success/payment-success.component';
import { PaymentErrorComponent } from './payment-error/payment-error.component';
import {ShareModule} from '../share/share.module';
import { NgxSliderModule } from '@angular-slider/ngx-slider';
import {ShortcutNumbersPipe} from '../helper/shortcut-numbers.pipe';
import {environment} from '../../environments/environment';
import {StripeModule} from 'stripe-angular';
import {SpecialOfferModule} from '../special-offer/special-offer.module';
import { PriceBoxComponent } from './pricing/price-box/price-box.component';
import { PricePopupComponent } from './pricing/price-popup/price-popup.component';
import { PricingQuantityComponent } from './pricing/pricing-quantity/pricing-quantity.component';
import { PricingTimeComponent } from './pricing/pricing-time/pricing-time.component';
import {BreadcrumbsComponent} from '../share/breadcrumbs/breadcrumbs.component';


@NgModule({
  declarations: [
    PaymentAddComponent,
    PaymentDetailsComponent,
    PaymentSuccessComponent,
    PaymentErrorComponent,
    PricingQuantityComponent,
    PricingTimeComponent
  ],
    imports: [
        PaymentRoutingModule,
        CommonModule,
        FormsModule,
        HttpClientModule,
        ReactiveFormsModule,
        ChartModule,
        ShareModule,
        NgxSliderModule,
        SpecialOfferModule,
        StripeModule.forRoot(environment.stripeKey),
        BreadcrumbsComponent
    ],
  providers: [
    PricingService,
    PaymentService,
    ShortcutNumbersPipe
  ]
})
export class PaymentModule {}
